/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appTrello_viewer$ref = any;
export type appTrello_QueryVariables = {||};
export type appTrello_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appTrello_viewer$ref,
  |}
|};
export type appTrello_Query = {|
  variables: appTrello_QueryVariables,
  response: appTrello_QueryResponse,
|};
*/


/*
query appTrello_Query {
  viewer {
    actualPersonId
    component(name: "app_trello")
    ...appTrello_viewer
    id
  }
}

fragment appTrello_viewer on Viewer {
  id
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_trello"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_trello\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appTrello_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appTrello_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appTrello_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appTrello_Query",
    "operationKind": "query",
    "text": "query appTrello_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_trello\")\n    ...appTrello_viewer\n    id\n  }\n}\n\nfragment appTrello_viewer on Viewer {\n  id\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e369fc9d40903ffd99059b9a25c676dd';

module.exports = node;
